import environment from "environment";
import HttpErrorResponseModel from "models/HttpErrorResponseModel";
import EffectUtility from "utilities/EffectUtility";
import CercaDettalgioPreventivoModel from "./models/CercaDettalgioPreventivoModel";
import CercaDettalgioSimulazioneModel from "./models/CercaDettalgioSimulazioneModel";
import CercaPreventiviModel from "./models/CercaPreventiviModel";
import CercaSimulazioneModel from "./models/CercaSimulazioneModel";

export interface ISearchSimulazioneRequest {
    pageNumber: number;
    pageSize: number;
    sortParam?: string;
    sortAsc?: boolean;
    requestType?: number;
    name?: string;
    creationDateFrom?: string;
    creationDateTo?: string;
    idAgent?: string;
    idChannel?: number;
    idSegment?: number;
    idProduct?: number;
    atc?: number;
    idAdministrativeCategory?: number;
    instalment?: number;
    duration?: number;
    amount?: number;
    idProductType?: number;
}

export interface ISearchPreventiviRequest {
    pageNumber: number;
    pageSize: number;
    sortParam?: string | null;
    sortAsc?: boolean;
    idEstimate?: string;
    idEstimateRequest?: string;
    idPractice?: string;
    creationDateFrom?: string;
    creationDateTo?: string;
    simulationName?: string;
    idSimulation?: string;
    idAgent?: string;
    idChannel?: number;
    idSegment?: number;
    requestType?: number;
    idProduct?: number;
    atc?: number;
    idAdministrativeCategory?: number;
    installment?: number;
    duration?: number;
    amount?: number;
    idProductType?: number;
    firstName?: string;
    lastName?: string;
    idStatoPrev?: number;
}
export default class CercaEffects {
    public static async cercaSimulazione(
        request: ISearchSimulazioneRequest
    ): Promise<CercaSimulazioneModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.searchSimulations;
        return EffectUtility.postToModel<CercaSimulazioneModel>(CercaSimulazioneModel, endpoint, request);
    }

    public static async dettaglioSimulation(
        id: number
    ): Promise<CercaDettalgioSimulazioneModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.findSimulation + `?idSimulation=${id}`;
        return EffectUtility.getToModel<CercaDettalgioSimulazioneModel>(CercaDettalgioSimulazioneModel, endpoint);
    }

    public static async simulazioniExportExcel(
        request: ISearchSimulazioneRequest,
        progressHandler: (progress: number) => void
    ): Promise<Blob | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulazioniExportExcel;
        return EffectUtility.getFile(endpoint, request, undefined, "POST");
    }

    public static async cercaPreventivi(
        request: ISearchPreventiviRequest
    ): Promise<CercaPreventiviModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.searchEstimates;
        return EffectUtility.postToModel<CercaPreventiviModel>(CercaPreventiviModel, endpoint, request);
    }

    public static async preventiviExportExcel(
        request: ISearchPreventiviRequest,
        progressHandler: (progress: number) => void
    ): Promise<Blob | HttpErrorResponseModel> {
        const endpoint: string = environment.api.preventiviExportExcel;
        return EffectUtility.getFile(endpoint, request, undefined, "POST");
    }

    public static async dettaglioPreventivo(
        id?: number,
        idEstimateRequest?: number
    ): Promise<CercaDettalgioPreventivoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.findEstimate;
        return EffectUtility.getToModel<CercaDettalgioPreventivoModel>(CercaDettalgioPreventivoModel, endpoint, {
            idEstimate: id,
            idEstimateRequest: idEstimateRequest,
        });
    }
    public static async FunctionsGet(): Promise<string[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.functions;
        return await EffectUtility.getToModel<string[]>(null, endpoint);
    }
}
